<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiCheck } from "@mdi/js";
export default {
  name: "MdiCheck",
  data() {
    return {
      svgPath: mdiCheck,
    };
  },
};
</script>
